import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/MsgBoxWarning.svg'


const _hoisted_1 = {
  class: "modal fade",
  id: "MsgBoxWarning",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-labelledby": "MsgBoxWarning",
  "aria-hidden": "true"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-dialog modal-dialog-centered\"><div class=\"modal-content\"><div class=\"modal-header msgbox-warning-title-area\"><img src=\"" + _imports_0 + "\" alt=\"\" width=\"20\" height=\"20\"><h6 class=\"modal-title ms-2\" id=\"MsgBoxWarning_Title\"></h6></div><div class=\"modal-body msgbox-warning-body-areabody\" id=\"MsgBoxWarning_Message\" style=\"white-space:pre-wrap;word-wrap:break-word;\"></div><div class=\"modal-footer msgbox-warning-buttons-area\"><button type=\"button\" id=\"MsgBoxWarning_OkButton\" class=\"btn btn-outline-primary msgbox-warning-dialog-buttons\" data-bs-dismiss=\"modal\">OK</button></div></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]


export default /*#__PURE__*/_defineComponent({
  __name: 'MsgBoxWarning',
  setup(__props) {


/********************************************************************************
 * シンプルメッセージボックス(Warning)
 *
 * @since 2023/03/23
 * @author 松本裕介
 *
 *********************************************************************************/


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}
}

})